import { render, staticRenderFns } from "./FormularioCtrlDesignacaoComponent.vue?vue&type=template&id=b375b102"
import script from "./FormularioCtrlDesignacaoComponent.vue?vue&type=script&lang=js"
export * from "./FormularioCtrlDesignacaoComponent.vue?vue&type=script&lang=js"
import style0 from "./FormularioCtrlDesignacaoComponent.vue?vue&type=style&index=0&id=b375b102&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports